import React, { FC, useCallback } from 'react';

import { IconCTA, IconCTAProps } from 'Src/components/buttons/IconCTA';
import { useLongPress } from 'Src/feature/long-press/useLongPress';

import { Seat, Table } from './useSeatAssignment';

import styles from './CheckItemSeatSelectionCTA.module.scss';

interface CheckItemSeatSelectionCTAProps {
  elRef?: IconCTAProps['ref'],
  model: Table | Seat;
  selected: boolean;
  onUI: (options: { model: Table | Seat; mode: 'click' | 'longpress' }) => void;
}

const CheckItemSeatSelectionCTA: FC<CheckItemSeatSelectionCTAProps> = ({
  elRef,
  selected,
  model,
  onUI,
  ...rest
}) => (
  <IconCTA
    {...rest}
    variant="outlined"
    ref={elRef}
    selected={selected}
    icon={{ jsx: <span className={styles.textIcon}>{model.shortName}</span> }}
    {...useLongPress({
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onClick: useCallback((event:  React.MouseEvent<HTMLButtonElement, MouseEvent>) => onUI({ model, mode: 'click' }), [model, onUI]),
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onLongPress: useCallback((event:  React.MouseEvent<HTMLButtonElement, MouseEvent>) => onUI({ model, mode: 'longpress' }), [model, onUI]),
      shouldPreventDefault: false,
    })}
  />
);

export { CheckItemSeatSelectionCTA };
export type { CheckItemSeatSelectionCTAProps };
